import {Size, Dependencies} from 'services/screen';

export function sizeOf(di: Dependencies = {}): Size {
  const {wndw = window} = di;

  return {
    width: wndw.innerWidth || 0,
    height: wndw.innerHeight || 0,
  };
}
